export const cmsDefault =
[
    {
        "key": "esp_email_InvalidPage_Error_Text",
        "value": {
            "microContentValue": "This page does not exist"
        }
    },
    {
        "key": "esp_email_InvalidSignUp_Error_Text",
        "value": {
            "microContentValue": "Error occurred. Kindly contact respective team."
        }
    },
    {
        "key": "esp_email_Label_CaptchaInvalid_Text",
        "value": {
            "microContentValue": "Invalid Captcha . Please Try Again"
        }
    },
    {
        "key": "esp_email_Label_Captcha_Text",
        "value": {
            "microContentValue": "Captcha"
        }
    },
    {
        "key": "esp_email_Label_EmailError_Text",
        "value": {
            "microContentValue": "Please enter a valid Email Address."
        }
    },
    {
        "key": "esp_email_Label_EmailMatchError_Text",
        "value": {
            "microContentValue": "Email IDs you have provided do not match."
        }
    },
    {
        "key": "esp_email_Label_FirstNameError_Text",
        "value": {
            "microContentValue": "Please provide correct First Name"
        }
    },
    {
        "key": "esp_email_Label_LastNameError_Text",
        "value": {
            "microContentValue": "Please provide correct Last Name"
        }
    },
    {
        "key": "esp_email_Label_Success_Text",
        "value": {
            "microContentValue": "Thank you for signing up."
        }
    },
    {
        "key": "esp_email_NSAPIDown_Error_Text",
        "value": {
            "microContentValue": "We apologize, but this page is not available right now. Please check back in a few minutes. Thank you."
        }
    },
    {
        "key": "esp_email_button_signUp_button",
        "value": {
            "microContentValue": "Sign Up for Email"
        }
    },
    {
        "key": "esp_email_header_label_text",
        "value": {
            "microContentValue": "would love to stay in touch to hear about your needs and to keep you updated on products, services, solutions, exclusive offers and special events."
        }
    },
    {
        "key": "esp_email_header_link_text",
        "value": {
            "microContentValue": "Dell Technologies and its group of companies"
        }
    },
    {
        "key": "esp_email_header_signUp_text",
        "value": {
            "microContentValue": "Sign Up for Dell Email Updates"
        }
    },
    {
        "key": "esp_email_offers_label_textEnd",
        "value": {
            "microContentValue": "to sign in and update your preference."
        }
    },
    {
        "key": "esp_email_offers_label_textStart",
        "value": {
            "microContentValue": "If you are already receiving great offers from Dell, you may click"
        }
    },
    {
        "key": "esp_email_offers_link_textHere",
        "value": {
            "microContentValue": "here"
        }
    },
    {
        "key": "esp_email_privacy_label_text",
        "value": {
            "microContentValue": "For more information about how Dell uses, shares, and protects your personal data, see our"
        }
    },
    {
        "key": "esp_email_privacy_link_text",
        "value": {
            "microContentValue": "Privacy Statement"
        }
    },
    {
        "key": "esp_email_textbox_placeholder_confirmEmailAddress",
        "value": {
            "microContentValue": "Confirm Email Address"
        }
    },
    {
        "key": "esp_email_textbox_placeholder_emailAddress",
        "value": {
            "microContentValue": "Email Address"
        }
    },
    {
        "key": "esp_email_textbox_placeholder_firstname",
        "value": {
            "microContentValue": "First Name"
        }
    },
    {
        "key": "esp_email_textbox_placeholder_lastname",
        "value": {
            "microContentValue": "Last Name"
        }
    },
    {
        "key": "ssp_Checkbox_Deals_Person",
        "value": {
            "microContentValue": "Personal Deals"
        }
    },
    {
        "key": "ssp_Checkbox_Deals_Professional",
        "value": {
            "microContentValue": "Professional Deals"
        }
    },
    {
        "key": "ssp_Checkbox_Know_Alienware",
        "value": {
            "microContentValue": "Alienware"
        }
    },
    {
        "key": "ssp_Checkbox_Know_Employees",
        "value": {
            "microContentValue": "Employees"
        }
    },
    {
        "key": "ssp_Checkbox_Know_Military",
        "value": {
            "microContentValue": "Military"
        }
    },
    {
        "key": "ssp_Checkbox_Know_Students",
        "value": {
            "microContentValue": "Students"
        }
    },
    {
        "key": "ssp_Deals_Mandatory_Error_Text",
        "value": {
            "microContentValue": "Please select the deal you are interested in."
        }
    },
    {
        "key": "ssp_DivHeader_SMSDeals",
        "value": {
            "microContentValue": "Dell Text Deals"
        }
    },
    {
        "key": "ssp_InvalidPage_Error_Text",
        "value": {
            "microContentValue": "This page does not exist"
        }
    },
    {
        "key": "ssp_InvalidPhone_Error_Text",
        "value": {
            "microContentValue": "phone number is invalid, please enter a new one."
        }
    },
    {
        "key": "ssp_Label_CaptchaInvalid_Text",
        "value": {
            "microContentValue": "Invalid Captcha , Please Try Again"
        }
    },
    {
        "key": "ssp_Label_Captcha_Text",
        "value": {
            "microContentValue": "Captcha*"
        }
    },
    {
        "key": "ssp_Label_CelllPhoneError_Text",
        "value": {
            "microContentValue": "Please provide correct mobile phone number"
        }
    },
    {
        "key": "ssp_Label_FirstNameError_Text",
        "value": {
            "microContentValue": "Please provide correct First Name"
        }
    },
    {
        "key": "ssp_Label_FormFillOutDisplay_Text",
        "value": {
            "microContentValue": "Please fill out the following form to start receiving text messages from Dell"
        }
    },
    {
        "key": "ssp_Label_InterestedDeals_Text",
        "value": {
            "microContentValue": "Where possible we can tailor your communications, which deals are you interested in?"
        }
    },
    {
        "key": "ssp_Label_KnowMore_Text",
        "value": {
            "microContentValue": "Would you also like to know more about?"
        }
    },
    {
        "key": "ssp_Label_LastNameError_Text",
        "value": {
            "microContentValue": "Please provide correct Last Name"
        }
    },
    {
        "key": "ssp_Label_SubmitIinfo_Text",
        "value": {
            "microContentValue": "By clicking Submit, you hereby consent to receive text message advertisements by an automated dialer and/or similar technology, from or on behalf of Dell Technologies, <a f=\"https://i.dell.com/sites/doccontent/legal/terms-conditions/en/Documents/Dell-Technologies-List-for-Privacy-Statement-May-2018.pdf\" target=\"_blank\" rel=\"noopener noreferrer\">its group of companies</a>, at the number provided. I understand that consent is not a condition of purchase or receiving a service and that I may opt-out of receiving text advertisements any time by replying or texting STOP to [95056]. Message frequency may vary. For more information on how Dell uses and protects your data, click <a href=\"https://www.dell.com/learn/ed/en/edcorp1/policies-privacy\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> for our Privacy Statement. Standard data and message rates apply."
        }
    },
    {
        "key": "ssp_Label_Success_Text",
        "value": {
            "microContentValue": "Thank you for signing up."
        }
    },
    {
        "key": "ssp_NSAPIDown_Error_Text",
        "value": {
            "microContentValue": "We apologize, but this page is not available right now. Please check back in a few minutes. Thank you."
        }
    },
    {
        "key": "ssp_SingupError_SamePhone_Text",
        "value": {
            "microContentValue": "You are already signed up for same deal"
        }
    },
    {
        "key": "ssp_Success_SMSPersonal_Text",
        "value": {
            "microContentValue": "Dell: Thank you for subscribing. For help, https://dell.to/3bIg3hp. Msg freq varies. Txt STOP to cancel. Std msg and data rates may apply."
        }
    },
    {
        "key": "ssp_Success_SMSProf_Text",
        "value": {
            "microContentValue": "Dell Small Biz: Thank you for subscribing. For help, https://dell.to/3bIg3hp. Msg freq varies. Txt STOP to cancel. Std msg and data rates may apply."
        }
    },
    {
        "key": "ssp_Success_SMSSent_Text",
        "value": {
            "microContentValue": "Dell: Thank you for subscribing. For help, https://dell.to/3ERa7A3. Msg freq varies. Txt STOP to cancel. Std msg and data rates may apply."
        }
    },
    {
        "key": "ssp_button_submit",
        "value": {
            "microContentValue": "Submit"
        }
    },
    {
        "key": "ssp_textbox_placeholder_cellnumber",
        "value": {
            "microContentValue": "Cell Phone Number*"
        }
    },
    {
        "key": "ssp_textbox_placeholder_firstname",
        "value": {
            "microContentValue": "First Name*"
        }
    },
    {
        "key": "ssp_textbox_placeholder_lastname",
        "value": {
            "microContentValue": "Last Name*"
        }
    },
    {
        key: "esp_email_privacy_consent_text",
        value: {
            microContentValue: "We will send you an email to confirm your email address and consent. Please follow the instructions in the email to complete the process.",
        },
    },
]